<template>
  <div class="leaseInfoStep">
    <QS-scroller-box>
      <!-- 订单信息 -->
      <div class="border mb16 mt16">
        <QS-column-box class="mt16" :column="3" :list="list" :source="source"  separator=":" />
      </div>

      <!-- 租赁信息 -->
      <QS-h4-title title="租赁信息"/>
      <!-- 确认租赁信息 -->
      <rentInfo
        ref="rentInfo"
        @updateInfo="updateRentDateInfo"
        :showDeposit="true"
        :deposit="deposit"
        :forbiddenEndDate="forbiddenEndDate"
        :defaultRentInfo="defaultRentInfo"
      />
      <!-- 租赁信息文本展示和支付计划表格 -->
      <rentLeasePlanInfo
        ref="rentLeasePlanInfo"
        :rentDateInfo="rentDateInfo"
        :defaultTableData="feeTableData"
        @autoAnchor="autoAnchor"
        @rentCategoryType="handleRentLeasePlanInfo"
      />
      <!-- 按钮 -->
      <template slot="bottomAction">
        <el-button size="mini" @click="cancel">取消</el-button>
        <el-button
          size="mini"
          type="primary"
          :loading="btnLoading"
          @click="submit">{{ submitText }}</el-button>
      </template>
    </QS-scroller-box>
  </div>
</template>
<script>
import { getRentOrderDetail } from '@/api/domain/underLease'
import rentInfo from '@/components/rentCalculateConfig/rentInfo.vue'
import rentLeasePlanInfo from '@/components/rentCalculateConfig/rentLeasePlanInfo.vue'
import { CATEGORY_FEE_MAP } from '@/store/dict/rentPlanDict.js'
import { isEmpty } from 'lodash'
import { mapState } from 'vuex'
import { ORDER_TYPE } from '../const'
import { orderAccruedplanvalidAccruedPlanAmountApi } from '@/api/domain/orders'

export default {
  name: 'OrderRenewalIndexB',
  inject: {
    deposit: {
      default: () => ({}),
    },
    getOrderConfigInfo: {
      default: () => ({}),
    },
  },
  props: {
    orderType: {
      type: String,
      default: '',
    },
    submitText: {
      type: String,
      default: '确认',
    }, // 提交按钮文字
    list: {
      type: Array,
      default: () => [],
    }, // 顶部基础信息展示列表
    source: {
      type: Object,
      default: () => ({}),
    }, // 顶部基础信息展示列表数据源
    params: {
      type: Object,
      default: () => ({}),
    }, // 提交所需要的其它参数  :submitApi="addRentOrderRenewal"
    submitApi: {
      type: Function,
      default: () => ({}),
    },
  },
  components: { rentInfo, rentLeasePlanInfo },
  data() {
    return {
      reqRentCategory: '',
      btnLoading: false,
      rentDateInfo: {
        category: '', // 类别
        signDate: '', // 签署日期
        startStopDate: '', // 收款起止日期
        presentDays: '', // 赠送天数
        isTranDeposit: '', // 是否平移原订单押金 1-是 0-否
        contractDateText: '', // 合同起止日期文本 eg: 2023-07-01~2023-07-31
        rentPeriodText: '', // 租期文本(天数) eg: 共7天
        presentDaysText: '', // 赠送天数文本 eg: 0天
      },
      feeTableData: [],
      defaultRentInfo: {
        isTranDeposit: 1,
      },
      // 是否回显过
      isModify: false,
    }
  },
  computed: {
    forbiddenEndDate() {
      return this.source.presentEntDate || this.source.endDate
    },
    // 订单配置信息
    orderConfigInfo() {
      return (this.getOrderConfigInfo && this.getOrderConfigInfo()) || {}
    },
    ...mapState({
      orderSignRentFee: (state) => state.rentPlan.orderSignRentFee, // 租车费项
      orderSignPurchaseFee: (state) => state.rentPlan.orderSignPurchaseFee, // 已租代购费项
      orderSignCooperateFee: (state) => state.rentPlan.orderSignCooperateFee, // 司机合作模式费项
    }),
  },
  watch: {
    orderConfigInfo: {
      async handler(val) {
        if (!val || isEmpty(val)) return
        this.defaultRentInfo = {
          rentCategory: val.rentCategory, // 类别
          signDate: `${val.signDate} 00:00:00`, // 签署日期
          startStopDate: [`${val.startDate} 00:00:00`, `${val.endDate} 00:00:00`], // 收款起止日期
          presentDays: val.presentDays, // 赠送天数
          isTranDeposit: val.orderConfig?.depositTransfer, // 是否平移原订单押金 1-是 0-否
        }
        this.rentDateInfo = {
          rentCategory: val.rentCategory, // 类别
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleRentLeasePlanInfo(rentCategory) {
      this.reqRentCategory = rentCategory
    },
    async updateRentDateInfo(rentInfoParams, feeTableData, from) {
      this.rentDateInfo = {
        ...rentInfoParams,
      }

      /**
       * 为了区分是取接口的数据还是取当前页面的数据，加入了事件标识，如果带有该标识，则一定是覆盖当前页面的数据，同时，由于
       */
      if (from === 'fromEvent') {
        this.isModify = true
        this.feeTableData = feeTableData
      }

      if (!this.isModify) {
        if (isEmpty(this.orderConfigInfo)) {
          this.feeTableData = feeTableData
          return
        }
        // 从Store里取出费项的配置列表
        const feeCategoryName = CATEGORY_FEE_MAP[this.orderConfigInfo.rentCategory]
        if (isEmpty(this[feeCategoryName])) {
          await this.$store.dispatch('getFeeList', { type: feeCategoryName })
        }
        // 合并费项配置列表
        this.feeTableData = this.orderConfigInfo.orderAccruedPlans.map((item) => {
          const feeCategories = this[feeCategoryName]
          const fee = feeCategories.find((i) => i.code === item.fundType)
          return {
            ...item,
            name: item.fundTypeName,
            required: fee.required, // 是否必填 boolean
            isConfirm: true,
            toast: fee.toast,
            isSelectScheme: Boolean(this.rentDateInfo.isTranDeposit),
          }
        })
      }
    },
    autoAnchor(toastFlag) {
      this.$refs.rentInfo.autoAnchorPoint(toastFlag)
    },
    // 获取个人订单信息
    async getPersonalOrderDetail(orderId, callback) {
      let res

      try {
        res = await getRentOrderDetail({
          orderId,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        callback && callback(data)
      }
    },
    // 提交
    submit() {
      const params = this.getParams()
      if (!params) {
        return
      }
      orderAccruedplanvalidAccruedPlanAmountApi({
        accruedPlanParamList: this.accruedPlanParamList,
        rentCategory: this.reqRentCategory }).then((res) => {
        if (res?.code === 1) {
          this.handlersubmit(params)
        }
      })
    },
    handlersubmit(params) {
      this.btnLoading = true

      // 批量续约提交时需要页面loading展示
      let screenLoading
      if (params.carInfoList && params.carInfoList.length > 1) {
        screenLoading = this.$loading({
          spinner: 'el-loading-spinner',
          background: 'rgba(255, 255, 255, 0.9)',
          lock: true,
        })
      }
      // 更新订单
      if (!isEmpty(this.orderConfigInfo)) {
        params.orderId = this.orderConfigInfo.orderId
      }
      this.submitApi(params).then((res) => {
        this.btnLoading = false
        screenLoading && screenLoading.close()
        if (res.code !== 1) return
        if (this.orderType !== ORDER_TYPE.Personal) {
          this.$message.success('创建成功')
        }
        // 个人订单发起续约成功后需要重新拉取订单信息
        if (this.orderType === ORDER_TYPE.Personal && res?.data?.id) {
          this.getPersonalOrderDetail(res.data.id, (data) => {
            this.$emit('orderCreateSuccess', data)
          })
        } else {
          this.$emit('orderCreateSuccess', res.data)
        }
      }).catch(() => {
        this.btnLoading = false
        screenLoading && screenLoading.close()
      })
    },
    // 获取提交参数
    getParams() {
      const returnData = false
      const leaseInfoParams = this.$refs.rentInfo.getFormData()
      if (!leaseInfoParams) {
        return returnData
      }
      const rentLeasePlanInfoParams = this.$refs.rentLeasePlanInfo.getFormData()
      if (!rentLeasePlanInfoParams) {
        return returnData
      }

      this.accruedPlanParamList = rentLeasePlanInfoParams.map((item) => {
        return { feeType: item.fundType, feeAmount: item.receivableTotalAmount }
      })
      // console.log(leaseInfoParams, rentLeasePlanInfoParams)
      // const [pledge, rent] = rentLeasePlanInfoParams
      const { rentCategory, signDate, startStopDate, presentDays, isTranDeposit } = leaseInfoParams
      const params = {
        rentCategory,
        signDate,
        startDate: startStopDate[0],
        endDate: startStopDate[1],
        presentDays,
        orderConfig: {
          depositTransfer: isTranDeposit,
        },
      }
      return {
        ...params,
        ...this.params,
        // addOrRenewal: 1, // 续约还是新增 1：续约，2：新增
        relatedType: 4,
        // amountType: rent.amountType, // 金额类型 0每期租金 1日租金
        // payPlanType: rent.schemeType, // 收款金额方案 0固定方案 1阶梯方案
        orderAccruedPlans: rentLeasePlanInfoParams || [],
      }
    },
    // 取消
    cancel() {
      this.$confirm('取消后可在「订单续约」列表继续操作订单确认流程，点击确定返回列表', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$router.back()
        this.$refreshBack(false)
      }).catch(() => null)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .border{
    padding:0 16px;
    box-sizing: border-box;
}
::v-deep .border .el-column-box{
  margin-bottom: 0;
}
</style>
<style lang="scss">

</style>
